import { LovDto } from '../types/swaggerTypes'

export const formatValueLabel = (value: string, list: LovDto[]) => {
  if (Array.isArray(list) && list.length > 0) {
    const found = list.find((item) => item.lovCode === value)
    if (found) {
      return found.lovValue
    }
  }

  return value
    .toLowerCase()
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}
